import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { copyFindExcursionsStore } from 'entities/excursions/models/copy-find-excursions/copy-find-excursions-store'

import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Paper } from 'shared/ui/paper'

import { CopyFindForm } from './components/copy-find-form/copy-find-form'
import s from './styles.module.scss'

const CopyFindFormPage = observer(() => {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const onGoBack = () => {
    copyFindExcursionsStore.resetFindCopy()

    navigate(-1)
  }

  const onSearch = () => {
    copyFindExcursionsStore.setCopyForSearch()

    navigate(RoutingPaths.excursion.search.path())
  }

  return (
    <div className={clsx('container', s.container)}>
      <div className={s.header}>
        <HeaderGoBack
          title={t('edit_search')}
          onGoBack={onGoBack}
          buttonWhite
        />
      </div>

      <Paper padding={[16]}>
        <p className={s.title}>{t('excursions.where_go')}</p>

        <p className={s.subTitle}>{t('excursions.kyrgyzstan_beautiful')}</p>

        <CopyFindForm onSearch={onSearch} />
      </Paper>
    </div>
  )
})

export default CopyFindFormPage
